// GAVION test mode (58_gavion_test_mode.sql): test leads and the dialer's admin-only « Mode test ».
export const testModeEn = {
  badge: "TEST",
  badge_hint:
    "Test lead: called only in test mode, never counted in the statistics.",
  lead_switch: "Test lead",
  lead_switch_hint:
    "Admins only. A test lead is called only in « Test mode » (at any hour) and never counts in the statistics.",
  dialer_switch: "Test mode",
  dialer_switch_hint:
    "Admins only: calls test leads only, at any hour. Starts a new session.",
  dialer_switch_busy: "Pick an outcome for the current call first.",
  banner: "Test mode — only test leads are called, calling hours ignored",
  empty:
    "No test lead to call right now. Create one, or add a number to a test lead.",
  create: "Create a test lead",
  default_name: "Test lead",
  created: "Test lead created. Add your phone number and email.",
  create_failed: "Could not create the test lead.",
  forbidden: "Test mode is for admins only.",
};
